import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Grid, Typography } from '@mui/material'

import { ParcelTapeWithQuestionMark } from '@dhl/illustrations'
import { Page } from '@dhl/page'

type ErrorMessagePageProps = {
  header?: string
  body?: string
  buttonLabel?: string
  onButtonClick?: () => void
  testId?: string
  withoutRouter?: boolean
}

type Props = Omit<ErrorMessagePageProps, 'header' | 'body' | 'buttonLabel'>

const ErrorMessagePage = ({
  header,
  body,
  buttonLabel,
  onButtonClick,
  testId,
  withoutRouter = false,
}: ErrorMessagePageProps) => (
  <Page hideMenu withoutRouter={withoutRouter} testId={testId || ''}>
    <Grid container wrap="nowrap" justifyContent="center" alignItems="center" direction="column">
      <Grid>
        <Box mt={8}>
          <ParcelTapeWithQuestionMark
            sx={{
              maxWidth: '80vw',
              width: '300px',
              height: '150px',
            }}
          />
        </Box>
      </Grid>
      <Grid>
        <Box mt={3} textAlign="center">
          <Typography variant="h2">{header || ''}</Typography>
        </Box>
      </Grid>
      <Grid>
        <Box mt={1}>
          <Typography>{body || ''}</Typography>
        </Box>
      </Grid>
      <Grid>
        <Box mt={3}>
          {buttonLabel && onButtonClick && (
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={onButtonClick}
              data-test="login-error-button"
            >
              {buttonLabel}
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  </Page>
)

export const AuthenticationErrorMessagePage: FC<Props> = (props) => {
  const { t } = useTranslation()

  return (
    <ErrorMessagePage
      header={t('authentication.authenticationErrorHeader')}
      body={t('authentication.authenticationErrorText')}
      buttonLabel={t('authentication.logOutButtonLabel')}
      {...props}
    />
  )
}

export const AuthorizationErrorMessagePage: FC<Props> = (props) => {
  const { t } = useTranslation()

  return (
    <ErrorMessagePage
      header={t('authentication.authorizationErrorHeader')}
      body={t('authentication.authorizationErrorText')}
      buttonLabel={t('authentication.logOutButtonLabel')}
      {...props}
    />
  )
}
